module.exports = __webpack_public_path__ + "img/Flag_of_Tunisia.c8085fc2.svg";